// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__wPs2e","icon":"SortAdornment_icon__3ho13","up":"SortAdornment_up__3JXbk","down":"SortAdornment_down__Wo7i3","active":"SortAdornment_active__222ma"};